var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{attrs:{"size":"small","disabled":_vm.captcha_disabled,"type":"primary"},on:{"click":_vm.sendCaptchaSubmit}},[_vm._v(_vm._s(_vm.captcha_text))])
}
var staticRenderFns = []

export { render, staticRenderFns }